import { computed, ref } from "vue";

import { isSusimdalClassAcademy } from "@/shared/config/const/susimdalClassAcademyIds";

const SEMINAR_MODE_STORAGE_KEY = "seminarModeEnabled";

const seminarModeEnabledRef = ref(localStorage.getItem(SEMINAR_MODE_STORAGE_KEY) === "true");

export const useSeminarMode = () => {
    const isSeminarModeEnabled = computed(() => seminarModeEnabledRef.value);

    const setSeminarModeEnabled = (enabled: boolean) => {
        seminarModeEnabledRef.value = enabled;
        localStorage.setItem(SEMINAR_MODE_STORAGE_KEY, String(enabled));
    };

    const getDefaultStudentDetailRouteName = (): "curriculum" | "student-information" => {
        return seminarModeEnabledRef.value ? "curriculum" : "student-information";
    };

    const shouldApplySeminarMode = (academyId: string): boolean => {
        return isSusimdalClassAcademy(academyId) && seminarModeEnabledRef.value;
    };

    const resolveStudentDetailRouteName = (
        academyId: string,
    ): "curriculum" | "student-information" => {
        if (!isSusimdalClassAcademy(academyId)) {
            return "student-information";
        }

        return getDefaultStudentDetailRouteName();
    };

    return {
        isSeminarModeEnabled,
        setSeminarModeEnabled,
        getDefaultStudentDetailRouteName,
        shouldApplySeminarMode,
        resolveStudentDetailRouteName,
    };
};
